import type { ObjectiveLevel } from './objective_levels'

// One quarterly objective as the anchor page's content carries it. In accordion mode each
// objective lists its own curated resource uuids.
export interface AnchorObjective {
  uuid?: string
  level: ObjectiveLevel
  title: string
  text: string
  resources?: string[]
}

export interface EditedObjective {
  text: string
  level: ObjectiveLevel
  title: string
}

// isAllObjectives marks an edit made through the list-wide Edit, which the page reports
// under obj_level 'all' rather than the objective's own level.
export interface ObjectiveEdit {
  index: number
  objective: EditedObjective
  isAllObjectives: boolean
}

export function objectiveContentTitle(objective: AnchorObjective): string {
  const quarter = `${objective.level} Quarter`
  if (!objective.title) {
    return quarter
  }
  return `${quarter}: ${objective.title}`
}
